var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ebox",style:(Object.assign({}, _vm.echartStyle,
    {maxHeight: _vm.echartType == 'bar' ? '' : '',
    height: (_vm.height + "px")})),attrs:{"id":_vm.uuid}})}
var staticRenderFns = []

export { render, staticRenderFns }